module.exports = __webpack_public_path__ + "static/img/uf-nominee-advanced-video-thumbnail.a2b4303e.png";